import React from "react";
import styled from "styled-components";
import { pxToRem } from "styles/utils";

export interface SummaryMetricCardProps {
  label: string;
  value: string;
  note?: React.ReactNode;
  progress?: number;
}

const Card = styled.div`
  min-width: 0;
  padding: ${pxToRem(18)} ${pxToRem(20)};
  border: ${pxToRem(1)} solid ${({ theme }) => theme.borders.outline};
  border-radius: ${({ theme }) => pxToRem(theme.radii.lg)};
  background: ${({ theme }) => theme.colors.white};
`;

const Label = styled.div`
  color: ${({ theme }) => theme.colors.inkSoft};
  font-size: ${pxToRem(16.25)};
`;

const Value = styled.div`
  margin: ${pxToRem(7)} 0 ${pxToRem(2)};
  color: ${({ theme }) => theme.colors.ink};
  font-size: ${pxToRem(32.5)};
  font-weight: 600;
  line-height: 1.15;
  letter-spacing: -0.02em;
  font-variant-numeric: tabular-nums;
`;

const Note = styled.div`
  min-height: ${pxToRem(18)};
  color: ${({ theme }) => theme.colors.inkMuted};
  font-size: ${pxToRem(16.25)};

  strong {
    color: ${({ theme }) => theme.colors.inkSoft};
    font-weight: 500;
  }
`;

const ProgressTrack = styled.div`
  height: ${pxToRem(7.5)};
  margin-top: ${pxToRem(12)};
  overflow: hidden;
  border-radius: ${({ theme }) => pxToRem(theme.radii.pill)};
  background: ${({ theme }) => theme.colors.inkSurface};
`;

const ProgressFill = styled.div<{ $progress: number }>`
  width: ${({ $progress }) => `${Math.min(100, Math.max(0, $progress))}%`};
  height: 100%;
  border-radius: inherit;
  background: ${({ theme }) => theme.colors.brand};
  transition: width 0.2s ease;
`;

const SummaryMetricCard: React.FC<SummaryMetricCardProps> = ({
  label,
  value,
  note,
  progress,
}) => (
  <Card>
    <Label>{label}</Label>
    <Value>{value}</Value>
    {typeof progress === "number" ? (
      <ProgressTrack aria-hidden="true">
        <ProgressFill $progress={progress} />
      </ProgressTrack>
    ) : (
      <Note>{note ?? ""}</Note>
    )}
  </Card>
);

export default SummaryMetricCard;
